import { useMemo } from "react";
import type { FormData } from "../hooks/useSubmissionForm";

interface ReviewStepProps {
  formData: FormData;
  photoUrl?: string;
}

const CATEGORY_LABELS: Record<string, string> = {
  dating: "Encontros",
  social: "Social",
  business: "Profissional",
};

const GENDER_LABELS: Record<string, string> = {
  any: "Qualquer",
  male: "Masculino",
  female: "Feminino",
};

export function ReviewStep({ formData, photoUrl }: ReviewStepProps) {
  const previewFile = formData.croppedFile ?? formData.imageFile;
  const previewUrl = useMemo(
    () => photoUrl ?? (previewFile ? URL.createObjectURL(previewFile) : null),
    [photoUrl, previewFile]
  );

  return (
    <div className="space-y-6">
      <div className="relative mx-auto max-w-xs overflow-hidden rounded-xl border border-border">
        {previewUrl ? (
          <img src={previewUrl} alt="Preview" className="w-full" />
        ) : (
          <div className="flex aspect-square w-full items-center justify-center bg-card text-muted-foreground">
            Carregando preview...
          </div>
        )}
      </div>

      <div className="rounded-xl border border-border bg-card p-4">
        <div className="space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Categoria</span>
            <span className="font-medium text-foreground">
              {CATEGORY_LABELS[formData.category ?? ""] ?? formData.category}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Tipo</span>
            <span className="font-medium text-foreground">
              {formData.isPaid ? "Pago" : "Gratuito"}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Meta de Votos</span>
            <span className="font-medium text-foreground">{formData.votesTarget} votos</span>
          </div>
          {formData.isPaid && formData.demographics && (
            <>
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground">Gênero do Público</span>
                <span className="font-medium text-foreground">
                  {GENDER_LABELS[formData.demographics.gender] ?? formData.demographics.gender}
                </span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground">Idade do Público</span>
                <span className="font-medium text-foreground">
                  {formData.demographics.minAge}-
                  {formData.demographics.maxAge === 150 ? "+" : formData.demographics.maxAge}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
